import { render, staticRenderFns } from "./teachers.vue?vue&type=template&id=2404b5de&scoped=true"
import script from "./teachers.vue?vue&type=script&lang=js"
export * from "./teachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2404b5de",
  null
  
)

export default component.exports